import type { AccessStatus } from '../types/agreementAccess.types';

export function deriveAccessState(status: AccessStatus): 'required' | 'granted' {
    if (!status.required) return 'granted';

    return status.justification && status.confirmed ? 'granted' : 'required';
}
